import {
  LOGIN,
  LOGIN_DONE,
  LOGIN_ERROR,
  CREATE_ACCOUNT,
  CREATE_ACCOUNT_DONE,
  CREATE_ACCOUNT_ERROR,
  EDIT_ACCOUNT,
  EDIT_ACCOUNT_DONE,
  EDIT_ACCOUNT_ERROR,
  GET_ACCOUNT_DONE,
  REQUEST_PASSWORD_RESET,
  REQUEST_PASSWORD_RESET_DONE,
  REQUEST_PASSWORD_RESET_ERROR,
  LOGOUT,
  GET_ACCOUNT_BY_ACCOUNT_ID,
  STORE_NEXT_URL,
  FETCH_AUTHORIZED_EVENT,
  FETCH_AUTHORIZED_EVENT_DONE,
  FETCH_USER_PURCHASES,
  FETCH_USER_PURCHASES_DONE,
  FETCH_ORDER_DETAILS,
  FETCH_ORDER_DETAILS_DONE,
  VERIFY_ACCOUNT_TOKEN,
  VERIFY_ACCOUNT_TOKEN_DONE,
  VERIFY_ACCOUNT_TOKEN_ERROR,
  RESET_ACCOUNT_PASSWORD,
  RESET_ACCOUNT_PASSWORD_DONE,
  RESET_ACCOUNT_PASSWORD_ERROR,
  POST_CONSUME_EVENT,
  LOGIN_SSO,
  CLEAN_NEXT_URL,
  CLEAR_AUTHORIZED_EVENT,
  CLEAR_ORDER_HISTORY,
  CLEAR_ORDER_DETAILS
} from "./constants";

export const login = (payload) => ({
  type: LOGIN,
  payload
});

export const loginDone = (payload) => ({
  type: LOGIN_DONE,
  payload
});

export const loginError = (error) => ({
  type: LOGIN_ERROR,
  error
});

export const createAccount = (payload) => ({
  type: CREATE_ACCOUNT,
  payload
});

export const createAccountDone = () => ({
  type: CREATE_ACCOUNT_DONE
});

export const createAccountError = (error) => ({
  type: CREATE_ACCOUNT_ERROR,
  error
});

export const editAccount = (payload) => ({
  type: EDIT_ACCOUNT,
  payload
});

export const editAccountDone = (payload) => ({
  type: EDIT_ACCOUNT_DONE,
  payload
});

export const editAccountError = (error) => ({
  type: EDIT_ACCOUNT_ERROR,
  error
});

export const logout = () => ({
  type: LOGOUT
});

export const loginSso = (payload) => ({
  type: LOGIN_SSO,
  payload
});

export const getAccountByAccountId = (accountId) => ({
  type: GET_ACCOUNT_BY_ACCOUNT_ID,
  accountId
});

export const getAccountDone = (payload) => ({
  type: GET_ACCOUNT_DONE,
  payload
});

export const requestPasswordReset = (payload) => ({
  type: REQUEST_PASSWORD_RESET,
  payload
});

export const requestPasswordResetDone = () => ({
  type: REQUEST_PASSWORD_RESET_DONE
});

export const requestPasswordResetError = (error) => ({
  type: REQUEST_PASSWORD_RESET_ERROR,
  error
});

export const storeNextUrl = (payload) => ({
  type: STORE_NEXT_URL,
  payload
});

export const cleanNextUrl = () => ({
  type: CLEAN_NEXT_URL
});

export const fetchAuthorizedEvent = (accountId, eventId) => ({
  type: FETCH_AUTHORIZED_EVENT,
  accountId,
  eventId
});

export const fetchAuthorizedEventDone = (payload) => ({
  type: FETCH_AUTHORIZED_EVENT_DONE,
  payload
});

export const clearAuthorizedEvent = () => ({
  type: CLEAR_AUTHORIZED_EVENT
});

export const fetchUserPurchases = (userId) => ({
  type: FETCH_USER_PURCHASES,
  userId
});

export const fetchUserPurchasesDone = (payload) => ({
  type: FETCH_USER_PURCHASES_DONE,
  payload
});

export const clearOrderHistory = () => ({
  type: CLEAR_ORDER_HISTORY
});

export const fetchOrderDetails = (orderId) => ({
  type: FETCH_ORDER_DETAILS,
  orderId
});

export const fetchOrderDetailsDone = (payload) => ({
  type: FETCH_ORDER_DETAILS_DONE,
  payload
});

export const clearOrderDetails = () => ({
  type: CLEAR_ORDER_DETAILS
});

export const postConsumeEvent = (payload) => ({
  type: POST_CONSUME_EVENT,
  payload
});

export const verifyUserToken = (token) => ({
  type: VERIFY_ACCOUNT_TOKEN,
  token
});

export const verifyUserTokenDone = (response) => ({
  type: VERIFY_ACCOUNT_TOKEN_DONE,
  payload: response
});

export const verifyUserTokenError = (error) => ({
  type: VERIFY_ACCOUNT_TOKEN_ERROR,
  payload: error
});

export const resetAccountPassword = (token, password) => ({
  type: RESET_ACCOUNT_PASSWORD,
  token,
  password
});

export const resetAccountPasswordDone = (response) => ({
  type: RESET_ACCOUNT_PASSWORD_DONE,
  payload: response
});

export const resetAccountPasswordError = (error) => ({
  type: RESET_ACCOUNT_PASSWORD_ERROR,
  payload: error
});
